import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SequenceVersion from './SequenceVersion';
import { getSequenceVersion, getUserProfileWidget, getCurrentTimezone,  getUserOrgModelCategoryType } from '../../selectors/index';
import {
  getSequenceVersionThunk,
  setCurrentPage,
  setFilteredDataThunk,
  sequenceVersionCleanUpThunk,
  setSequenceVersionChangeThunk,
  saveSequenceVersionThunk
} from '../../actions/sequenceVersion';



const mapStateToProps = state => {
  return {
    sequenceVersionManager: getSequenceVersion(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSequenceVersions: (modelCategoryId, modelId) => getSequenceVersionThunk('SEQUENCEVERSIONLIST', modelCategoryId, modelId),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setFilteredData: filter => setFilteredDataThunk(filter),
      sequenceVersionCleanUp: sequenceVersion => sequenceVersionCleanUpThunk(sequenceVersion),
      saveSequenceVersion: (sequenceVersion, widgetCode) => saveSequenceVersionThunk(sequenceVersion, widgetCode),
      changeSequenceVersion: sequenceVersion => setSequenceVersionChangeThunk(sequenceVersion)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SequenceVersion);
